import { render, staticRenderFns } from "./TireList.vue?vue&type=template&id=942ed694&scoped=true"
import script from "./TireList.vue?vue&type=script&lang=ts"
export * from "./TireList.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "942ed694",
  null
  
)

export default component.exports